import React, { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import ErrorBoundary from './components/ErrorBoundary';
import LoadingSpinner from './components/LoadingSpinner';
import './styles/globals.css';
import './styles/App.css';
import './styles/light-editorial.css';

const App = () => (
  <ErrorBoundary>
    <Suspense fallback={<LoadingSpinner />}>
      <RouterProvider router={router} />
    </Suspense>
  </ErrorBoundary>
);

export default App;
